import React from "react";
import { useFieldArray } from "react-final-form-arrays";

import Tooltip from "rc-tooltip";
import DOMPurify from "dompurify";

const FieldErrorTableInput = ({
  field_name,
  field_array_name,
  column_name,
  index,
  currentErrors,
  // returningToPage,
  // returningToForm,
  children,
}) => {
  let field = field_name || "_";
  const {
    meta: { touched, error },
    fields: { value },
  } = useFieldArray(field, {
    subscription: { touched: true, error: true, value: true },
  });

  const toolTipContent = (content) => (
    <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }} />
  );

  let errorMessage = "";
  let toolTipMessage = null;

  let showValue = value && value.length > 20;
  if (error && error != undefined) {
    errorMessage = error;
  }
  if (
    currentErrors &&
    currentErrors[field_array_name] &&
    currentErrors[field_array_name][index] &&
    currentErrors[field_array_name][index][column_name]
  ) {
    errorMessage = currentErrors[field_array_name][index][column_name];
  }

  if (showValue && errorMessage) {
    toolTipMessage = value + "<br><br>" + errorMessage;
  } else if (showValue) {
    toolTipMessage = value;
  } else if (errorMessage) {
    toolTipMessage = errorMessage;
  }
  let dataTip = errorMessage || showValue;
  return (
    <Tooltip
      trigger={["hover"]}
      overlay={() => toolTipContent(toolTipMessage)}
      placement={dataTip ? "top" : "bottom"}
      getTooltipContainer={() => document.querySelector(".ReactModalPortal")}
    >
      <td className={errorMessage ? "usa-table-input-error" : ""}>
        {children}
      </td>
    </Tooltip>
  );
};

export default FieldErrorTableInput;
